import { useTranslation } from '@/contexts/i18n-context';
import { UserEntryLayout } from '@/components/auth/user-entry-layout';
import { Section } from '@/components/containers/section';
import styles from './user-entry-success-card.module.css';
import { Button } from '@/components/button';
import clsx from 'clsx';

interface UserEntrySuccessCardProps {
  title: string;
  subtitle: React.ReactNode;
  icon: React.ReactNode;
  hasLoginButton?: boolean;
}

export function UserEntrySuccessCard({
  title,
  subtitle,
  icon,
  hasLoginButton,
}: UserEntrySuccessCardProps) {
  const { t } = useTranslation();

  return (
    <UserEntryLayout>
      <Section className={styles.successSection}>
        {icon}
        <div className={styles.textSection}>
          <h1 className={clsx('h3', styles.text)}>{title}</h1>
          <p className={styles.text}>{subtitle}</p>
        </div>
        {hasLoginButton && (
          <Button as="a" to="/login" fullWidth rightIcon="arrow_forward">
            {t('common.logIn')}
          </Button>
        )}
      </Section>
    </UserEntryLayout>
  );
}
